module.exports = __webpack_public_path__ + "img/logoTruck.36a3a3ce.jpg";